"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.name = void 0;
const React = __importStar(require("react"));
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const theme_1 = require("theme");
const icons_1 = __importDefault(require("constants/icons"));
const constants_1 = require("constants/constants");
const model_1 = require("constants/model");
const services_1 = require("services");
const PurchaseSummary_1 = require("components/partial/PurchaseSummary");
const OrdersPartial_1 = require("components/partial/orders/OrdersPartial");
const FullScreenLoad_1 = __importDefault(require("components/custom/FullScreenLoad"));
const url_1 = require("utils/url");
const context_1 = require("components/context");
const modal_1 = require("components/modal");
const carrito_1 = require("services/carrito");
exports.name = "MyShoppingCartName";
const MyShoppingCart = ({ navigation, route }) => {
    React.useEffect(() => {
        const unsuscribe = navigation.addListener("focus", () => {
            carritoList();
        });
        return unsuscribe;
    }, [navigation, route.params?.quoteClientId]);
    const authContext = React.useContext(context_1.AuthContext);
    const toast = (0, native_base_1.useToast)();
    const [isLoading, setIsLoading] = React.useState(false);
    const [showModalSobreDiscount, setShowModalSobreDiscount] = React.useState(false);
    const [shoppingCartResponse, setShoppingCartResponse] = React.useState(undefined);
    const [productsGroupAlertType, setProductsGroupAlertType] = React.useState();
    const productAddingSobreDiscount = React.useRef();
    const carritoList = () => {
        const onSuccess = (response) => {
            setShoppingCartResponse(response);
            let groups = [];
            response.data?.forEach(product => {
                if (groups.find(group => group.type == (product.stockAlertReasonType ?? ""))) {
                    groups.find(group => group.type == (product.stockAlertReasonType ?? ""))?.products?.push(product);
                }
                else {
                    groups.push({
                        type: product.stockAlertReasonType ?? "",
                        products: [product],
                    });
                }
            });
            setProductsGroupAlertType(groups);
        };
        (0, services_1.doCarritoList)({
            params: {
                clientId: route.params.quoteClientId,
            },
            callback: {
                onSuccess,
                onLoading: setIsLoading,
            },
        });
    };
    React.useEffect(() => {
        carritoList();
    }, []);
    const onBackPres = () => {
        navigation.jumpTo(OrdersPartial_1.name);
    };
    const removeProduct = React.useCallback((shoppingCartItem) => {
        const onSuccess = (response) => {
            route.params?.updateProducts?.();
            carritoList();
        };
        const onFailSessionExpired = authContext?.signOut;
        (0, services_1.doCarritoRemove)({
            params: {
                data: {
                    procodigo: shoppingCartItem?.codigo,
                },
            },
            callback: {
                onSuccess: onSuccess,
                onFailSessionExpired,
            },
        });
    }, [navigation]);
    const [editMode, setEditMode] = React.useState(false);
    const onEditPress = () => {
        setEditMode(!editMode);
    };
    const carritoAffect = ({ procodigo, free, reasonCode }) => {
        const onSuccess = (response) => {
            carritoList();
        };
        const onFailSessionExpired = authContext?.signOut;
        (0, services_1.doCarritoAffect)({
            params: {
                procodigo: procodigo,
                cond: free ? model_1.ShoppingCart.COND_FREE : model_1.ShoppingCart.COND_GRAV,
                motivo: reasonCode,
            },
            callback: {
                onSuccess,
                onFailSessionExpired,
            },
        });
    };
    const clearShoppingCart = () => {
        const onSuccess = () => {
            carritoList();
            navigation.goBack();
        };
        (0, services_1.doCarritoClear)({
            params: {},
            callback: {
                onSuccess: onSuccess,
            },
        });
    };
    const timeoutIdAdd = React.useRef(undefined);
    const carritoAdd = (product, size) => {
        clearTimeout(timeoutIdAdd.current);
        const callCarritoAdd = () => {
            const onSuccess = () => {
                carritoList();
            };
            (0, services_1.doCarritoAdd)({
                params: {
                    clientId: route.params.quoteClientId,
                    data: {
                        procodigo: product?.codigo,
                        cantidad: size,
                        stockAlert: product.stockAlert,
                        stockAlertFecha: product.stockAlertFecha,
                        stockAlertReason: product.stockAlertReason,
                        stockAlertReasonType: product.stockAlertReasonType,
                        stockAlertColor: product.stockAlertColor,
                    },
                },
                callback: {
                    onSuccess,
                },
            });
        };
        timeoutIdAdd.current = setTimeout(callCarritoAdd, 1000);
    };
    const addSobreDiscountPressed = (product) => {
        productAddingSobreDiscount.current = product;
        setShowModalSobreDiscount(true);
    };
    const renderItem = ({ item }) => (<ShoppingItemGroup shoppingCartItem={item} removeProduct={removeProduct} carritoAffect={carritoAffect} carritoAdd={carritoAdd} addSobreDiscountPressed={addSobreDiscountPressed} editMode={editMode}/>);
    const onSendOrderPress = () => {
        if ((shoppingCartResponse?.data?.length ?? 0) > 0) {
            console.log("navigate to PurchaseSummaryName warehouseCode=", route?.params?.warehouseCode);
            navigation.navigate(PurchaseSummary_1.name, {
                warehouseCode: route?.params?.warehouseCode,
                quoteClientId: route?.params?.quoteClientId,
                quoteId: route?.params?.quoteId,
            });
        }
        else {
            toast.show({ description: theme_1.Str.enterAProductToYourOrders });
        }
    };
    const onSobreDiscountAcceptPressed = (discount, product) => {
        setShowModalSobreDiscount(false);
        const onSuccess = (response) => {
            carritoList();
        };
        const onFailSessionExpired = authContext?.signOut;
        (0, carrito_1.doCarritoSobreDiscount)({
            params: {
                almacen: route?.params?.warehouseCode,
                data: {
                    procodigo: productAddingSobreDiscount.current?.codigo,
                    descuento: discount,
                },
            },
            callback: {
                onSuccess,
                onFailSessionExpired,
            },
        });
    };
    return (<>
			<native_base_1.ScrollView style={styles.container} p={{ base: 20, md: 30 }}>
				<native_base_1.HStack style={styles.layoutHeader} flexWrap="wrap" justifyContent="flex-end">
					<native_base_1.HStack minW={{ base: "100%", lg: "none" }} alignItems="center" flex={{ base: undefined, lg: 1 }}>
						<native_base_1.HStack alignItems="center">
							<native_base_1.Pressable onPress={onBackPres}>
								<native_base_1.Image width={15} height={15} marginRight="10" source={require("images/ic_back.svg")} alt={theme_1.Str.alt.ic_back}/>
							</native_base_1.Pressable>
							<native_base_1.Heading variant="h1">{theme_1.Str.myShoppingCart}</native_base_1.Heading>
							{shoppingCartResponse?.visualizarAlertLineaCredito == true &&
            shoppingCartResponse?.lineasuperada == 1 && (<native_base_1.Text style={styles.txtCreditLine} variant="body6">
										{theme_1.Str.creditLineExceeded}
									</native_base_1.Text>)}
						</native_base_1.HStack>

						<native_base_1.HStack minW="105" alignItems="center" justifyContent="flex-end" flex={1}>
							{(0, url_1.getUserTypeFromUrl)() == constants_1.UserType.RV && (<native_base_1.Pressable onPress={onEditPress}>
									<native_base_1.HStack alignItems="center">
										<native_base_1.Text bg={editMode ? "colorVividRed1" : "colorLimeGreen1"} color="white" borderRadius="8" variant="body5" px="10" mr="10">
											{editMode ? "Cerrar" : "Abrir"}
										</native_base_1.Text>
										<native_base_1.View style={styles.imgEditLayout}>
											<native_base_1.Image style={[
                styles.imgEdit,
                {
                    tintColor: editMode
                        ? theme_1.Colors.colorLimeGreen1
                        : theme_1.Colors.colorTextPrimary,
                },
            ]} source={require("images/ic_edit.svg")} alt="icono de editar"/>
										</native_base_1.View>
									</native_base_1.HStack>
								</native_base_1.Pressable>)}
						</native_base_1.HStack>
					</native_base_1.HStack>

					<OrdersPartial_1.ShoppingCartIndicator onClearShoppingCartPress={clearShoppingCart} shoppingCartSize={shoppingCartResponse?.data?.length?.toString() ?? ""} minW="100" ml="15" mt={{ base: 10, lg: 0 }}/>
				</native_base_1.HStack>

				<native_base_1.FlatList key={shoppingCartResponse?.data
            ?.map(element => Number(element.cantidad) ?? 0)
            ?.reduce((acc, current) => acc + current, 0)} data={productsGroupAlertType} renderItem={renderItem} keyExtractor={item => item?.codigo}/>

				<native_base_1.VStack style={styles.layoutItems}>
					<native_base_1.View style={styles.layoutPrices}>
						<native_base_1.VStack>
							<native_base_1.Text variant="body23">{theme_1.Str.subtotal}</native_base_1.Text>
							<native_base_1.Text variant="body23" mt={{ base: 3, md: 9 }}>
								{theme_1.Str.igv}
							</native_base_1.Text>
							<native_base_1.Text style={[styles.txtPriceTotalTitle]} variant="h23">
								{theme_1.Str.total}
							</native_base_1.Text>
						</native_base_1.VStack>
						<native_base_1.Text style={[styles.txtIgvPercent]} variant="body23">
							(18%)
						</native_base_1.Text>
						<native_base_1.VStack alignItems="flex-end">
							<native_base_1.Text variant="body23">{shoppingCartResponse?.subtotal || ""}</native_base_1.Text>
							<native_base_1.Text variant="body23" mt={{ base: 3, md: 9 }}>
								{shoppingCartResponse?.igv || ""}
							</native_base_1.Text>
							<native_base_1.Text variant="h23">{shoppingCartResponse?.total || ""}</native_base_1.Text>
						</native_base_1.VStack>
					</native_base_1.View>
				</native_base_1.VStack>

				<native_base_1.Button style={styles.btnSendOrder} isDisabled={editMode} onPress={onSendOrderPress}>
					{theme_1.Str.sendOrder}
				</native_base_1.Button>
			</native_base_1.ScrollView>
			<modal_1.ModalSobreDiscount product={productAddingSobreDiscount.current} isOpen={showModalSobreDiscount} onClose={() => {
            setShowModalSobreDiscount(false);
        }} onAccept={onSobreDiscountAcceptPressed}/>
			<FullScreenLoad_1.default isVisible={isLoading}/>
		</>);
};
const ShoppingItemGroup = ({ shoppingCartItem, removeProduct, carritoAffect, carritoAdd, addSobreDiscountPressed, editMode, }) => {
    const renderItem = ({ item }) => (<ShoppingItem shoppingCartItem={item} removeProduct={removeProduct} carritoAffect={carritoAffect} carritoAdd={carritoAdd} addSobreDiscountPressed={addSobreDiscountPressed} editMode={editMode}/>);
    return (<native_base_1.VStack flex="1" minW={100} mt={15}>
			{shoppingCartItem?.products[0]?.stockAlertReason && (<native_base_1.HStack alignSelf="flex-start" background={`${shoppingCartItem?.products[0]?.stockAlertReasonType == "2"
                ? shoppingCartItem?.products[0]?.stockAlertColor ?? "#ffffff"
                : ""}`} borderRadius={10} px={10}>
					<native_base_1.Text variant="h3">{`${shoppingCartItem?.products[0]?.stockAlertReason ?? ""} `}</native_base_1.Text>
					<native_base_1.View background={`${shoppingCartItem?.products[0]?.stockAlertColor ?? "#ffffff"}`} borderRadius={10} px={10}>
						<native_base_1.Text variant="h3">{`${shoppingCartItem?.products[0]?.stockAlertFecha ?? ""}`}</native_base_1.Text>
					</native_base_1.View>
				</native_base_1.HStack>)}

			<native_base_1.FlatList style={styles.layoutItems} key={shoppingCartItem?.products
            ?.map(element => Number(element.cantidad) ?? 0)
            ?.reduce((acc, current) => acc + current, 0)} data={shoppingCartItem?.products} renderItem={renderItem} keyExtractor={item => item?.codigo}/>
		</native_base_1.VStack>);
};
const ShoppingItem = ({ shoppingCartItem, removeProduct, carritoAffect, carritoAdd, addSobreDiscountPressed, editMode, }) => {
    const authContext = React.useContext(context_1.AuthContext);
    const [size, setSize] = React.useState(shoppingCartItem?.cantidad);
    const [showModal, setShowModal] = React.useState(false);
    const handleSizeChange = (newSize) => {
        if (!isNaN(Number(newSize))) {
            setSize(newSize);
            carritoAdd(shoppingCartItem, Number(newSize));
        }
    };
    const onCheckBoxFreeChanged = (isSelected) => {
        if (isSelected && authContext?.loginData?.usaPromo == true && authContext.loginData?.uidtipo == "RV") {
            setShowModal(true);
        }
        else {
            carritoAffect({
                procodigo: shoppingCartItem?.codigo,
                free: isSelected,
                reasonCode: "",
            });
        }
    };
    const addSobreDiscountPressedInternal = () => {
        addSobreDiscountPressed(shoppingCartItem);
    };
    return (<>
			<native_base_1.HStack style={{
            flexDirection: "row",
            borderBottomColor: theme_1.Colors.colorLightGray1,
            borderBottomWidth: 2,
        }} px={{ base: 15, md: 30 }} py={{ base: 12, md: 22 }} flexWrap="wrap" alignItems="flex-start" justifyContent="space-between">
				<native_base_1.VStack flex="1" minW={100}>
					<native_base_1.Text variant="h23">{shoppingCartItem?.nombre || ""}</native_base_1.Text>
					<native_base_1.Text variant="body6" mt={{ base: 0, md: 5 }}>
						{shoppingCartItem?.codigo ?? ""}
					</native_base_1.Text>
				</native_base_1.VStack>

				<native_base_1.VStack>
					<native_base_1.Text variant="h23">P.Unit</native_base_1.Text>
					<native_base_1.Text variant="body5">{`${shoppingCartItem?.preciounit ?? ""}`}</native_base_1.Text>
				</native_base_1.VStack>

				<native_base_1.VStack mx={{
            base: 15,
            md: 30,
        }}>
					<native_base_1.Text variant="h23">Cant</native_base_1.Text>
					<native_base_1.Input value={size} onChangeText={handleSizeChange} w="60" mt="4" py="2" px="3" textAlign="center" borderWidth={2} borderColor="colorTextPrimary" borderRadius="7" fontFamily={theme_1.Fonts.bold}/>
				</native_base_1.VStack>

				<native_base_1.VStack w={100} alignItems="flex-end">
					<native_base_1.Text variant="h23">{shoppingCartItem?.precio ?? ""}</native_base_1.Text>
					<native_base_1.Text variant="body5">{shoppingCartItem?.preciobase ?? ""}</native_base_1.Text>
					<native_base_1.Text variant="body5">{`DESC: ${shoppingCartItem?.descuentoView ?? ""}`}</native_base_1.Text>
				</native_base_1.VStack>

				<native_base_1.VStack>
					{editMode && (<native_base_1.VStack alignSelf="center">
							{authContext?.loginData?.usaGratuito == true &&
                (authContext?.loginData?.uidtipo == "RV" ||
                    authContext?.loginData?.uidtipo == "SN") && (<native_base_1.Checkbox value="" isChecked={shoppingCartItem?.free == 1} ml="20" alignSelf="center" onChange={onCheckBoxFreeChanged}>
										Gratuito
									</native_base_1.Checkbox>)}
						</native_base_1.VStack>)}

					{shoppingCartItem?.motivoDesc && (<native_base_1.Text variant="body6" ml="20">
							{shoppingCartItem?.motivoDesc ?? ""}
						</native_base_1.Text>)}
				</native_base_1.VStack>

				<native_base_1.VStack alignSelf="center" ml={15}>
					<native_base_1.IconButton onPress={() => {
            removeProduct(shoppingCartItem);
        }} p="9" bg="colorLightGrayishBlue1" alignSelf="center" icon={<native_base_1.Image source={icons_1.default.icTrash} w="15" h="15"/>}/>
					{shoppingCartItem.aplicaSobreDesc == true && (<native_base_1.Button mt={10} onPress={addSobreDiscountPressedInternal} startIcon={<native_base_1.Image source={require("images/ic_plus")} variant="iconButtonRightSm" alt={theme_1.Str.alt.ic_plus} style={{ tintColor: theme_1.Colors.colorBtnSecondaryIcon }}/>} colorScheme={theme_1.Colors.btnSecondary.name} _text={{
                color: theme_1.Colors.colorBtnSecondaryText,
            }} size="sm"></native_base_1.Button>)}
				</native_base_1.VStack>
			</native_base_1.HStack>
			<modal_1.ModalSelectPromotionReason onSelectedPromotionReason={(reason) => {
            //setValue(address.rzonsocialtransp);
            setShowModal(false);
            //onSelectedTransport(address);
            if (reason) {
                carritoAffect({
                    procodigo: shoppingCartItem?.codigo,
                    free: true,
                    reasonCode: reason?.code,
                });
            }
        }} isOpen={showModal} onClose={() => setShowModal(false)}/>
		</>);
};
const styles = react_native_1.StyleSheet.create({
    container: {
        width: "100%",
    },
    layoutHeader: {
        width: "100%",
        alignItems: "center",
    },
    txtCreditLine: {
        paddingHorizontal: 10,
        paddingVertical: 3,
        marginStart: 20,
        backgroundColor: theme_1.Colors.colorVividRed1,
        borderRadius: theme_1.Sizes.configRadiusSm,
        color: "white",
    },
    imgEditLayout: {
        backgroundColor: "white",
        padding: 10,
        borderRadius: 30,
    },
    imgEdit: {
        width: 15,
        height: 15,
    },
    layoutItems: {
        width: "100%",
        marginTop: 20,
        paddingBottom: 20,
        backgroundColor: "white",
        borderRadius: theme_1.Sizes.configRadius,
    },
    layoutPrices: {
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 30,
        paddingVertical: 20,
    },
    txtIgvPercent: {
        flex: 1,
        marginStart: 40,
    },
    txtPriceTotalTitle: {
        textTransform: "uppercase",
    },
    btnSendOrder: {
        marginTop: 20,
        alignSelf: "flex-end",
    },
});
exports.default = MyShoppingCart;
